import { IStore } from '../../../models/redux-store';

export const selectAllDiscounts = (state: IStore) => state.shop.discounts;
export const selectDiscount = (productId?: number) => (state: IStore) =>
    productId ? selectAllDiscounts(state)[productId] : undefined;
export const selectDiscountByBusinessMeaning = (businessMeaning?: number) => (state: IStore) =>
    Object.values(selectAllDiscounts(state)).find(
        (discount) => discount.businessMeaning === businessMeaning
    );
